import { render } from "./UploadPOD.vue?vue&type=template&id=22e51414&scoped=true"
import script from "./UploadPOD.vue?vue&type=script&lang=js"
export * from "./UploadPOD.vue?vue&type=script&lang=js"

import "./UploadPOD.vue?vue&type=style&index=0&id=22e51414&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22e51414"]])

export default __exports__